module.exports = __webpack_public_path__ + "static/media/SuperShuttle_ios_1_preview.68b47f86.jpg";